export enum MatchEndReason {
  DEATH = "DEATH",
  EXTRACTION_SUCCESS = "EXTRACTION_SUCCESS",
  TIMEOUT = "TIMEOUT",
}
export type MatchEndData = {
  reason: MatchEndReason;
  trophies: number;
  matchEvents: { amount: number; reason: string }[];
  dailyRewardMilestone?: number; // Only set if player earned a reward (1, 3, or 5)
  dailyChallenge?: { day: number; creditsAwarded: number }; // Set if this extraction completed today's daily challenge day
  seasonXp: number; // seasonXp total before this match's gain, mirrors `trophies`
  seasonXpEvents: { amount: number; reason: string }[]; // mirrors `matchEvents`
  isNoobMatch: boolean; // True if this was a solo match for a player with 0 successful extractions
};
